module.exports = __webpack_public_path__ + "img/smile--default.d6000aeb.svg";